import { useQuery } from "@tanstack/react-query";
import { Cable } from "lucide-react";
import { apiGet } from "../shared/apiClient";
import { CollapsibleSection } from "../components/CollapsibleSection";
import { SerialeRemotaSection } from "../components/SerialeRemotaSection";
import { ProgrammazioneImpiantiSection } from "../components/utilita/ProgrammazioneImpiantiSection";
import { ReportGiornalieriSection } from "../components/utilita/ReportGiornalieriSection";
import { StoricoImpiantoSection } from "../components/utilita/StoricoImpiantoSection";

interface SquadraMe {
  id: string;
  nome: string;
  permessoProgrammazione?: "nessuna" | "download" | "download_upload";
  abilitaSerialeRemota?: boolean;
}

export function UtilitaPage() {
  const { data: meData } = useQuery<SquadraMe>({
    queryKey: ["squadra-me"],
    queryFn: async () => (await apiGet<SquadraMe>("/squadre/me")).data,
  });

  const permessoProg = meData?.permessoProgrammazione || "download";
  const canDownloadProg = permessoProg !== "nessuna";
  const canUploadProg = permessoProg === "download_upload";

  return (
    <div className="space-y-4 max-w-4xl mx-auto pb-6">
      <ProgrammazioneImpiantiSection
        canDownloadProg={canDownloadProg}
        canUploadProg={canUploadProg}
      />

      {meData?.abilitaSerialeRemota && (
        <CollapsibleSection
          icon={Cable}
          iconClass="bg-indigo-600 text-white"
          title="Porta Seriale Remota (COM Virtuale TCP)"
          subtitle="Collega l'adattatore USB-Seriale allo smartphone per consentire la programmazione da PC remoto"
          defaultOpen={false}
        >
          <SerialeRemotaSection />
        </CollapsibleSection>
      )}

      <ReportGiornalieriSection />

      <StoricoImpiantoSection />
    </div>
  );
}
